const o = "GeolocationCookieService";
export {
  o as GEOLOCATION_COOKIE_SERVICE
};
